// extracted by mini-css-extract-plugin
module.exports = {"container":"_jumbotrontwo_container__3Hv3s","body":"_jumbotrontwo_body__41C1v"};